import { TypedResult } from 'onboarding/types/result'

export function preparePhoneCode(value: string): TypedResult<string> {
  const noZeros = Number(value)
  if (Number.isNaN(noZeros)) {
    return { data: null, error: new Error(`Invalid phone code is provided: ${value}`) }
  }

  return { data: noZeros.toString(), error: null }
}
